"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createProxyMiddleware = createProxyMiddleware;
const http_proxy_middleware_1 = require("./http-proxy-middleware");
function createProxyMiddleware(options) {
    const { middleware } = new http_proxy_middleware_1.HttpProxyMiddleware(options);
    return middleware;
}
